/**
 * Zod schema for multiselect and tags fields.
 * Message: Required "Select at least one option."
 */

import { z } from 'zod';
import type { FieldSchemaConfig } from '../types';

export function getMultiselectSchema(col: FieldSchemaConfig): z.ZodTypeAny {
  const required = 'required' in col && col.required === true;

  const arrSchema = z.array(z.any());

  if (required) {
    return arrSchema.min(1, 'Select at least one option.');
  }
  return arrSchema;
}
